import { createContext, useContext, useState, useCallback, useEffect } from "react";
import pt from "./pt";
import en from "./en";
import es from "./es";
import fr from "./fr";

export const LANGS = [
  { code: "pt", label: "PT", name: "Português" },
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
  { code: "fr", label: "FR", name: "Français" },
];

const translations = { pt, en, es, fr };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("bloom-lang");
    return translations[saved] ? saved : "pt";
  });

  const setLang = useCallback((code) => {
    if (translations[code]) {
      localStorage.setItem("bloom-lang", code);
      setLangState(code);
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-PT" : lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
